<template>
  <b-button
    :variant="variant"
    :class="buttonClass"
    :size="size"
    @click="click"
  >
    <slot />
  </b-button>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: 'A művelethez megerősítés szükséges. Folytatni szeretnéd?',
    },
    url: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'post'
    },
    variant: {
      type: String,
      default: 'danger'
    },
    modalVariant: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    callback: {
      type: Function,
      default: () => false
    },
    checkCode: {
      type: Function,
      default: (code) => code > 199 && code < 300
    }
  },
  data() {
    return {
      title: 'Megerősítés',
      ok: 'Igen',
      cancel: 'Mégsem',
    }
  },
  mounted() {
  },
  methods: {
    handleResponse(code) {
      if (this.checkCode(code)) {
        var result = this.callback()
        if(result === false) {
          window.location.reload()
        } else {
          window.location = result
        }
      } else {
        this.$bvToast.toast('Hiba történt a művelet végrehajtása közben!', {
          title: 'Hiba',
          variant: 'danger'
        })
      }
    },
    click() {
      this.$bvModal.msgBoxConfirm(this.message, {
        title: this.title,
        okVariant: this.modalVariant === '' ? this.variant : this.modalVariant,
        okTitle: this.ok,
        cancelTitle: this.cancel
      }).then(value => {
        if(value) {
          this.$store.commit('enableLoading')
          this.$http[this.method](this.url)
            .then((response) => {
              this.handleResponse(response.status)
            })
            .catch(error => {
              if (error.response) {
                this.handleResponse(error.response.status)
              }
            })
            .finally(() => {
              this.$store.commit('disableLoading')
            })
        }
      })
    }
  }
}
</script>